// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7043) return "static/chunks/framer-motion-be361dc6c35cf564.js";
	if (chunkId === 9173) return "static/chunks/supabase-44db9aa713266431.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1019":"b1c6991804134cd3","1594":"d9acd67fc91ed8d3","1824":"e4585ac23b968547","2951":"39b7939fcf573055","3074":"02d080a763054628","5391":"f43c748af95c9364","5419":"1225cdd6fada4d27","7253":"2fb9d5cf37dc1e2c","7926":"0548d13e6f519f15","9852":"761735c622ac1081"}[chunkId] + ".js";
};